<template>
    <div class="dashboard-leader container-fluid" id="dashboard-leader">
        <div>
            <div class="mb-4">
                <p style="font-weight: 700; font-size: 30px; color: #020202" class="greeting">
                    Chào <span style="color: #493193">{{ currentUser?.name }}</span
                >, Hôm nay bạn đã sẵn sàng chưa?
                </p>
            </div>
            <div class="d-flex justify-content-end mb-2" v-if="tasks.length > 0">
                <img @click="dialogNotificationTask=true" style="width: 40px; height: 30px" src="@/assets/img/ring.webp" alt="warning bell" />
            </div>
        </div>



        <el-row :gutter="20">
            <!-- Cột 1: Lời chào + chức danh + doanh số nhập + nút chọn loại doanh số -->
            <el-col :xs="24" :sm="12" :md="12" :lg="5" :xl="5">
                <Sales-input/>
            </el-col>

            <!-- Cột 2: Các box mục tiêu -->
            <el-col :xs="24" :sm="12" :md="12" :lg="isActiveSale || isActiveManager ? 6 : 8" :xl="8">
                <el-row :gutter="0">
                    <el-col v-if="isActiveSale || isDoubleView" :xs="24" :sm="24" :md="12" :lg="isActiveSale ? 24: 12" class="pr-1">
                        <result :listPreGoal="listGoal" @reload="getGoal()"/>
                    </el-col>
                    <!-- Khu vực show của đội-->
                    <el-col v-if="isActiveManager || isDoubleView" :xs="24" :sm="24" :md="12" :lg="isActiveManager ? 24: 12" class="pl-1">
                        <expectedReport :listGoal="listGoalManager" @reload="getGoalManager()"/>
                    </el-col>
                </el-row>
            </el-col>

            <!-- Cột 3: Leader board -->
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
                <Leader-board :loading="loading_personal"/>
            </el-col>

            <!-- Cột 4: Thông báo -->
            <el-col :xs="24" :sm="12" :md="12" :lg="isActiveManager  ? 7 : (isDoubleView ? 5 : 7)" :xl="5">
                <notification/>
            </el-col>

            <!-- Cột 4: lịch sử -->
            <el-col :xs="24" :sm="12" :md="12" :lg="isActiveManager ? 7 : (isDoubleView ? 5 : 7)" :xl="5">
                <history v-if="![7].includes(keyAccount)" style="height: 50%"/>
            </el-col>
        </el-row>

        <el-dialog title="Nhắc nhở công việc được giao" :visible.sync="dialogNotificationTask" width="80%">
            <hr>
            <dialogTaskWithCustomer :tableData="tasks" :is_show="dialogNotificationTask" :is_dashboard="true"></dialogTaskWithCustomer>
        </el-dialog>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import {mapGetters, mapState} from "vuex";
import notification from "./component/NotificationDashboard.vue";
import history from "./component/HistoryDashboard.vue";
import LeaderBoard from "./component/LeaderBoardComponent.vue";
import SalesInput from "./component/SalesInput.vue";
import result from "./component/ResultDashboard.vue";
import expectedReport from "./component/ExpectedReportDashboard.vue";
import {GET_GOAL, GET_MANAGER_GOAL} from "@/core/services/store/report.module";

import { GET_TASK_SALE } from '@/core/services/store/customer/customer.module'
import DialogNotificationSupportEndCourse from "../customer/DialogNotificationSupportEndCourse.vue";
import DialogTaskWithCustomer from "./component/DialogTaskWithCustomer.vue";


export default {
    name: "DashboardLeader",
    components: {
        DialogNotificationSupportEndCourse,
        VueApexCharts,
        notification,
        history,
        LeaderBoard,
        SalesInput,
        result,
        expectedReport,
        DialogTaskWithCustomer
    },
    data() {
        return {
            is_personal: true,
            loading_personal: false,
            listGoal: [],
            listGoalManager: [],
            dialogNotificationTask: false,
            tasks: []
        };
    },
    computed: {
        ...mapState({
            errors: state => state.auth.errors
        }),
        ...mapGetters(["currentUser", 'keyAccount', 'isActiveManager', 'isActiveSale', 'isDoubleView']),
    },
    mounted() {
        this.getTaskWithCustomer();
        this.getGoal();
        this.computeLevelPositions();
        window.addEventListener("resize", this.onResize, { passive: true })
    },
    methods: {
        podiumClass(index) {
            return ["second-place", "first-place", "third-place"][index];
        },
        getGoal() {
            const date = this.$moment().format("YYYY-MM-DD");
            this.$store.dispatch(GET_GOAL, {date: date}).then((res) => {
                if (res) {
                    this.listGoal = res;
                }
            });
        },
        getGoalManager() {
            const date = this.$moment().format("YYYY-MM-DD");
            this.$store.dispatch(GET_MANAGER_GOAL, {date: date}).then((res) => {
                if (res) {
                    this.listGoalManager = res;
                }
            });
        },

        getTaskWithCustomer() {
            this.$store.dispatch(GET_TASK_SALE).then(res => {
                this.tasks = res.data;
                if(this.tasks.length > 0) {
                    this.dialogNotificationTask = true;
                }
            })
        }
    },
};
</script>

<style>
#dashboard-leader .card-target {
    background-color: rgba(244, 245, 255, 0.8);
    border-radius: 10px;
    border-width: 1px;
}

#dashboard-leader .target-title {
    font-family: SVN-Gilroy;
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0px;
}
</style>
